import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Label, Button } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

import apiResponse from '../../../../../services/apiResponse'
import IndexBloc from '../Blocs/IndexBloc'
import DepartureModal from './DepartureModal'
import ArrivalModal from './ArrivalModal'
import ReturnModal from './ReturnModal'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class TableComponent extends Component {

    indexBloc = new IndexBloc()

    source
    historyTable = 'EmployeeTransferMutasiTPLNTableActive'
    defaultOrder = 'employee_transfer_detail_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            departureUuid: null,
            departureModal: false,
            arrivalUuid: null,
            arrivalModal: false,
            returnUuid: null,
            returnModal: false,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }


    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1, 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchList(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        // await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.listChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.listChannel?.unsubscribe()
    }

    columns = [
        {
            key: "employee_transfer_detail_decree_date",
            text: "Tanggal SK",
            sortable: true,
            cell: record => {
                return reformatDate(record.employee_transfer_detail_decree_date)
            }
        },
        {
            key: "employee_transfer_detail_decree_number",
            text: "SK",
            sortable: true,
            cell: record => {
                return <a href={record.document?.documents_path} target="_blank">{record.employee_transfer_detail_decree_number}</a>
            }
        }, 
        {
            key: "employee_transfer_detail_kemenlu_decree_document",
            text: "SK Kemenlu",
            sortable: true,
            width: '150px',
            cell: record => {
                // return <a href={record.skkemenlu?.documents_path} target="_blank" className="btn btn-success btn-sm">{record.skkemenlu ? record.skkemenlu?.documents_name : '#'}</a>
                return (
                    <a href={record.skkemenlu?.documents_path} target="_blank" className="btn btn-success btn-sm">
                        <i className="uil-download-alt"></i> Download
                    </a>
                )
            }
        }, 
        {
            key: "employee_transfer_detail_position_name",
            text: "Jabatan",
            sortable: true,
        },
        {
            key: "employee_transfer_detail_country_name",
            text: "Negara Penempatan",
            sortable: true,
        },
        {
            key: "employee_transfer_detail_departure_date",
            text: "Waktu Keberangkatan",
            sortable: true, 
            cell: record => {
                return (
                    <Fragment>
                        <Label>Tanggal Berangkat: <br/> {reformatDate(record.employee_transfer_detail_departure_date)}</Label> <br/>
                        <Label>
                            Bukti:{' '}
                            {
                                record.doc_departure ?  
                                    <a href={record.doc_departure?.documents_path} target="_blank" className="btn btn-success btn-sm">
                                        <i className="uil-download-alt"></i> Download
                                    </a>
                                : '-'
                            }
                        </Label> <br/>
                        { record.employee_transfer_detail_return_date == null && 
                            <Button 
                                size="sm" 
                                color="warning"
                                onClick={() => this.setState({ departureUuid: record.employee_transfer_detail_uuid, departureModal: true })}
                            >
                                <i className="uil-pen"></i>
                            </Button>                       
                        }
                    </Fragment>
                )
            }
        },
        {
            key: "employee_transfer_detail_arrival_date",
            text: "Waktu Tiba",
            sortable: true, 
            cell: record => {
                return (
                    <Fragment>
                        <Label>Tanggal Tiba: <br/> {reformatDate(record.employee_transfer_detail_arrival_date)}</Label> <br/>
                        <Label>
                            Bukti:{' '}
                            {
                                record.doc_arrival ?  
                                    <a href={record.doc_arrival?.documents_path} target="_blank" className="btn btn-success btn-sm">
                                        <i className="uil-download-alt"></i> Download
                                    </a>
                                : '-'
                            }
                        </Label> <br/>

                        { record.employee_transfer_detail_return_date == null && 
                            <Button 
                                size="sm" 
                                color="warning"
                                onClick={() => this.setState({ arrivalUuid: record.employee_transfer_detail_uuid, arrivalModal: true })}
                            >
                                <i className="uil-pen"></i>
                            </Button>
                        }
                    </Fragment>
                )
            }
        },
        {
            key: "employee_transfer_detail_return_date",
            text: "Waktu Kepulangan",
            sortable: true, 
            cell: record => {
                return (
                    <Fragment>
                        <Label>Tanggal Pulang: <br/> {reformatDate(record.employee_transfer_detail_return_date)}</Label> <br/>
                        <Label>
                            Bukti:{' '}
                            {
                                record.doc_return ?  
                                    <a href={record.doc_return?.documents_path} target="_blank"className="btn btn-success btn-sm">
                                        <i className="uil-download-alt"></i> Download
                                    </a>
                                : '-'
                            }
                        </Label> <br/>

                        { record.employee_transfer_detail_return_date == null && 
                            <Button 
                                size="sm" 
                                color="warning"
                                onClick={() => this.setState({ returnUuid: record.employee_transfer_detail_uuid, returnModal: true })}
                            >
                                <i className="uil-pen"></i>
                            </Button>
                        }
                    </Fragment>
                )
            }
        },
    ]

    render() {
        return (
            <Fragment>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />               
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/mutasi_pegawai.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/mutasi_pegawai.html?create&uuid=" + this.state.updateUuid}/>
                : null }

                <DepartureModal uuid={this.state.departureUuid} modal={this.state.departureModal}  toggle={() => this.setState({ departureModal: !this.state.departureModal })} handleReload={() => this.loadData()} />
                <ArrivalModal uuid={this.state.arrivalUuid} modal={this.state.arrivalModal}  toggle={() => this.setState({ arrivalModal: !this.state.arrivalModal })} handleReload={() => this.loadData()} />
                <ReturnModal uuid={this.state.returnUuid} modal={this.state.returnModal}  toggle={() => this.setState({ returnModal: !this.state.returnModal })} handleReload={() => this.loadData()} />

            </Fragment>
        )
    }
}

export default TableComponent;